export default __webpack_public_path__ + "static/media/property_526.ce461958.png";